import { Icons } from '@/components/icons';
import { Badge } from '@/components/ui/badge';
import { DateTime } from 'luxon';

export type NotationDates = {
  startDate?: string | null;
  endDate?: string | null;
};

// Dates are inclusive whole days, matching the server-side `endDate lt! today`.
export const getNotationStatus = (notation: NotationDates) => {
  if (!notation.startDate) return null;

  const today = DateTime.now().startOf('day');
  const start = DateTime.fromISO(notation.startDate).startOf('day');
  const end = notation.endDate
    ? DateTime.fromISO(notation.endDate).startOf('day')
    : null;

  if (today < start) return 'pending';
  if (end && today > end) return 'closed';
  return 'active';
};

export function SpaceNotationStatusBadge({
  notation,
}: {
  notation: NotationDates;
}) {
  const status = getNotationStatus(notation);

  if (!status) return <Badge variant='gray'>Okänd status</Badge>;
  if (status === 'active') return <Badge variant='green'>Pågående</Badge>;
  if (status === 'pending') return <Badge variant='blue'>Kommande</Badge>;
  if (status === 'closed') return <Badge variant='destructive'>Avslutad</Badge>;

  return null;
}

export function SpaceNotationBlockedActionsBadge({
  blockedAction,
}: {
  blockedAction: string;
}) {
  return (
    <Badge
      variant='outline'
      className='flex items-center gap-1 bg-surface px-2'
    >
      <Icons.locked className='size-3' /> {blockedAction}
    </Badge>
  );
}
